import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { InspectionModelService } from '../../../shared/services/index';
import { Inspection } from '../../../shared/models/index';
import { BaseModalPageComponent } from '../../../base-modal.component';

@Component({
    selector: 'add-point-page',
    templateUrl: './add-point.component.html',
    standalone: false
})
export class AddPointPageComponent extends BaseModalPageComponent implements OnInit {
  inspections: Inspection[];
  inspectionId: string;
  sectionId: string;
  selectedInspection: Inspection;
  errorMessage: string;

  public loading: Boolean = true;

  constructor(
    public service: InspectionModelService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      let id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      let sectionId = params['sectionId'];
      if (sectionId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.sectionId = sectionId;

      this.initData();
    });
  }

  selectInspection(inspection: Inspection): void {
    this.selectedInspection = inspection;
  }

  openInspection(): void {
    this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'sections',
      this.sectionId,
      'addpoint',
      this.selectedInspection.id
    ]);
  }

  cancel() {
    this.goToBack();
  }

  initData(): void {
    this.service.getPublishedModels().subscribe((data) => {
      this.inspections = data;
      this.loading = false;
    });
  }
}
